import { toast as sonnerToast } from 'sonner';

type ToastOptions = {
  description?: string;
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
};

/**
 * Показывает уведомление об ошибке
 * @param message - Сообщение об ошибке
 * @param options - Дополнительные опции (описание, длительность, действие)
 */
export const toastError = (message: string, options?: ToastOptions) => {
  return sonnerToast.error(message, {
    description: options?.description,
    duration: options?.duration ?? 5000,
    action: options?.action,
  });
};

/**
 * Показывает уведомление об успехе
 * @param message - Сообщение об успехе
 * @param options - Дополнительные опции (описание, длительность, действие)
 */
export const toastSuccess = (message: string, options?: ToastOptions) => {
  return sonnerToast.success(message, {
    description: options?.description,
    duration: options?.duration ?? 3000,
    action: options?.action,
  });
};

/**
 * Показывает информационное уведомление
 * @param message - Информационное сообщение
 * @param options - Дополнительные опции (описание, длительность, действие)
 */
export const toastInfo = (message: string, options?: ToastOptions) => {
  return sonnerToast.info(message, {
    description: options?.description,
    duration: options?.duration ?? 4000,
    action: options?.action,
  });
};

/**
 * Показывает предупреждающее уведомление
 * @param message - Предупреждающее сообщение
 * @param options - Дополнительные опции (описание, длительность, действие)
 */
export const toastWarning = (message: string, options?: ToastOptions) => {
  return sonnerToast.warning(message, {
    description: options?.description,
    duration: options?.duration ?? 4000,
    action: options?.action,
  });
};

/**
 * Показывает уведомление о загрузке
 * @param message - Сообщение о загрузке
 * @param options - Дополнительные опции (описание)
 * @returns Функция для обновления или завершения загрузки
 */
export const toastLoading = (message: string, options?: { description?: string }) => {
  return sonnerToast.loading(message, {
    description: options?.description,
  });
};

/**
 * Показывает promise-уведомление (автоматически обновляется при resolve/reject)
 * @param promise - Promise для отслеживания
 * @param messages - Сообщения для разных состояний
 */
export const toastPromise = <T>(
  promise: Promise<T>,
  messages: {
    loading: string;
    success: string | ((data: T) => string);
    error: string | ((error: unknown) => string);
  },
) => {
  return sonnerToast.promise(promise, {
    loading: messages.loading,
    success: messages.success,
    error: messages.error,
  });
};
